<template>
    <div class="wtw-container small wtw-form account-create-container clearfix">

        <!-- CARD INFO -->

        <label class="first-label">Card Information </label>
        <div class="input-container">
            <input v-model="billing.card.name"
                   v-validate="'required'"
                   type="text"
                   name="name"
                   placeholder="Name on Card"
                   :class="{'error': errors.has('name') }"
            />
            <span v-show="errors.has('name')" class="error-message">{{ errors.first('name') }}</span>
        </div>
        <div class="input-container">
            <input v-model="billing.card.number"
                   v-validate="'credit_card|required'"
                   type="text"
                   name="number"
                   placeholder="Card Number"
                   :class="{'error': errors.has('number') }"
            />
            <span v-show="errors.has('number')" class="error-message">{{ errors.first('number') }}</span>
        </div>
        <div class="clearfix">
            <div class="input-container half-input first">
                <input v-model="billing.card.expiration"
                       v-validate="'date_format:MM/YY|required'"
                       type="text"
                       name="expiration"
                       placeholder="Expiration Date"
                       :class="{'error': errors.has('expiration') }"
                />
                <span v-show="errors.has('expiration')" class="error-message">{{ errors.first('expiration') }}</span>
            </div>
            <div class="input-container half-input">
                <input v-model="billing.card.ccv"
                       v-validate="'required'"
                       type="text"
                       name="ccv"
                       placeholder="CCV"
                       :class="{'error': errors.has('ccv') }"
                />
                <span v-show="errors.has('ccv')" class="error-message">{{ errors.first('ccv') }}</span>
            </div>
        </div>


        <!-- BILLING ADDRESS -->

        <label>Billing Address </label>
        <div class="input-container">
            <input v-model="billing.billingAddress.name"
                   v-validate="'required'"
                   type="text"
                   name="billing_address_name"
                   placeholder="Name"
                   :class="{'error': errors.has('billing_address_name') }"
            />
            <span v-show="errors.has('billing_address_name')" class="error-message">{{ errors.first('billing_address_name') }}</span>
        </div>
        <div class="input-container">
            <input v-model="billing.billingAddress.addressLine1"
                   v-validate="'required'"
                   type="text"
                   name="billing_address_line_1"
                   placeholder="Address Line 1"
                   :class="{'error': errors.has('billing_address_line_1') }"
            />
            <span v-show="errors.has('billing_address_line_1')" class="error-message">{{ errors.first('billing_address_line_1') }}</span>
        </div>
        <div class="input-container">
            <input v-model="billing.billingAddress.addressLine2"
                   type="text"
                   name="billing_address_line_2"
                   placeholder="Address Line 2"
            />
        </div>
        <div class="input-container">
            <input v-model="billing.billingAddress.city"
                   type="text"
                   name="billing_address_city"
                   placeholder="City"
                   :class="{'error': errors.has('billing_address_city') }"
            />
            <span v-show="errors.has('billing_address_city')" class="error-message">{{ errors.first('billing_address_city') }}</span>
        </div>

        <div class="clearfix">
            <div class="input-container half-input first">
                <div class="select-fix">
                    <select v-model="billing.billingAddress.state" name="billing_address_state"
                            :class="{'error': errors.has('billing_address_city') }">
                        <option :value="null">State</option>
                        <option v-for="state in states" :value="state">
                            {{ state }}
                        </option>
                    </select>
                </div>
                <span v-show="errors.has('billing_address_state')" class="error-message">{{ errors.first('billing_address_state') }}</span>
            </div>
            <div class="input-container half-input">
                <input v-model="billing.billingAddress.zip"
                       v-validate="'required'"
                       type="text"
                       name="billing_address_zip"
                       placeholder="Zip"
                       :class="{'error': errors.has('billing_address_zip') }"
                />
                <span v-show="errors.has('billing_address_zip')" class="error-message">{{ errors.first('billing_address_zip') }}</span>
            </div>
        </div>


        <!-- SHIPPING ADDRESS -->

        <label>Shipping Address </label>
        <div class="wtw-checkbox-container">
            <div class="wtw-checkbox" :class="{active:shippingAddressSameAsBilling}"
                 @click.stop="copyBillingAddressToShipping"></div>
            <span>Shipping same as billing</span>
        </div>
        <div class="input-container">
            <input v-model="billing.shippingAddress.name"
                   v-validate="'required'"
                   type="text"
                   name="shipping_address_name"
                   placeholder="Name"
                   :class="{'error': errors.has('shipping_address_name') }"
            />
            <span v-show="errors.has('shipping_address_name')" class="error-message">{{ errors.first('shipping_address_name') }}</span>
        </div>
        <div class="input-container">
            <input v-model="billing.shippingAddress.addressLine1"
                   v-validate="'required'"
                   type="text"
                   name="shipping_address_line_1"
                   placeholder="Address Line 1"
                   :class="{'error': errors.has('shipping_address_line_1') }"
            />
            <span v-show="errors.has('shipping_address_line_1')" class="error-message">{{ errors.first('shippingaddress_line_1') }}</span>
        </div>
        <div class="input-container">
            <input v-model="billing.shippingAddress.addressLine2"
                   type="text"
                   name="shipping_address_line_2"
                   placeholder="Address Line 2"
            />
        </div>
        <div class="input-container">
            <input v-model="billing.shippingAddress.city"
                   type="text"
                   name="shipping_address_city"
                   placeholder="City"
                   :class="{'error': errors.has('shipping_address_city') }"
            />
            <span v-show="errors.has('shipping_address_city')" class="error-message">{{ errors.first('shipping_address_city') }}</span>
        </div>
        <div class="input-container half-input first">
            <div class="select-fix">
                <select v-model="billing.shippingAddress.state" name="shipping_address_state"
                        :class="{'error': errors.has('shipping_address_city') }">
                    <option :value="null">State</option>
                    <option v-for="state in states" :value="state">
                        {{ state }}
                    </option>
                </select>
            </div>
            <span v-show="errors.has('shipping_address_state')" class="error-message">{{ errors.first('shipping_address_state') }}</span>
        </div>
        <div class="input-container half-input">
            <input v-model="billing.shippingAddress.zip"
                   v-validate="'required'"
                   type="text"
                   name="shipping_address_zip"
                   placeholder="Zip"
                   :class="{'error': errors.has('shipping_address_zip') }"
            />
            <span v-show="errors.has('shipping_address_zip')" class="error-message">{{ errors.first('shipping_address_zip') }}</span>
        </div>

    </div>
</template>

<script>
    export default{
        data(){
            return {
                shippingAddressSameAsBilling: false,
                billing: {
                    card: {
                        name: null,
                        number: null,
                        expiration: null,
                        ccv: null,
                    },
                    billingAddress: {
                        name: null,
                        addressLine1: null,
                        addressLine2: null,
                        city: null,
                        state: null,
                        zip: null
                    },
                    shippingAddress: {
                        name: null,
                        addressLine1: null,
                        addressLine2: null,
                        city: null,
                        state: null,
                        zip: null
                    }
                },
                states: ["AK",
                    "AL",
                    "AR",
                    "AS",
                    "AZ",
                    "CA",
                    "CO",
                    "CT",
                    "DC",
                    "DE",
                    "FL",
                    "GA",
                    "GU",
                    "HI",
                    "IA",
                    "ID",
                    "IL",
                    "IN",
                    "KS",
                    "KY",
                    "LA",
                    "MA",
                    "MD",
                    "ME",
                    "MI",
                    "MN",
                    "MO",
                    "MS",
                    "MT",
                    "NC",
                    "ND",
                    "NE",
                    "NH",
                    "NJ",
                    "NM",
                    "NV",
                    "NY",
                    "OH",
                    "OK",
                    "OR",
                    "PA",
                    "PR",
                    "RI",
                    "SC",
                    "SD",
                    "TN",
                    "TX",
                    "UT",
                    "VA",
                    "VI",
                    "VT",
                    "WA",
                    "WI",
                    "WV",
                    "WY"]
            }
        },
        props: ['options', 'sendOptions', 'optionsAll'],
        methods: {
            copyBillingAddressToShipping(){
                this.shippingAddressSameAsBilling = !this.shippingAddressSameAsBilling;
                if (this.shippingAddressSameAsBilling) {
                    this.billing.shippingAddress = this.billing.billingAddress
                } else {
                    this.billing.shippingAddress = {
                        name: null,
                        addressLine1: null,
                        addressLine2: null,
                        city: null,
                        state: null,
                        zip: null
                    }
                }
            }
        },
        watch: {
            sendOptions: function () {
                if (this.sendOptions) {
                    this.$parent.$emit('accountSignup');
                }
            }
        },
    }
</script>